import { Button, Flex, Grid, Input, Select, Text, useToast } from '@chakra-ui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import 'react-quill/dist/quill.snow.css'

import { z } from 'zod'
import { apiBlog } from '../../../services/api'
import { uploadImagePost } from './functions/uploadImagePost'

import { TextEditor } from '../../../components/TextEditor'
import { useDispatch, useSelector } from 'react-redux'
import { addDraft, updateDraft, deleteDraft, toggleShowDrafts } from '../../../redux/features/drafts/draftSlice'
import DraftsList from './DraftsList'
import { DragAndDrop } from '../../../components/DragAndDrop'

const IMAGE_UPLOAD_SIZE = 100000
const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']

const schema = z.object({
  title: z.string().nonempty('Título é obrigatório'),
  content: z.string().nonempty('Conteúdo é obrigatório'),
  featured: z
    .string()
    .nonempty('Destaque é obrigatório')
    .transform((value) => value === 'true'),
  timeToRead: z
    .string()
    .nonempty('Tempo de leitura é obrigatório')
    .transform((value) => parseInt(value)),
  files: z
    .any()
    .refine((file) => file?.size <= IMAGE_UPLOAD_SIZE, `Tamanho máximo de 100kb.`)
    .refine((file) => ACCEPTED_IMAGE_TYPES.includes(file?.type), 'Only .jpg, .jpeg, .png and .webp formats are supported.'),
})

export function CreateNewPost({ userBlog, setOpenModalLoginBlog }) {
  const toast = useToast()
  const dispatch = useDispatch()
  const drafts = useSelector((state) => state.drafts)

  const isAuthenticatedBlog = !!userBlog

  const { handleSubmit, register, control, formState, setValue } = useForm({
    resolver: zodResolver(schema),
  })

  async function handleSave(data) {
    if (!isAuthenticatedBlog) {
      return setOpenModalLoginBlog(true)
    }

    //se a imagem for maior que 100kb, não deixa salvar

    if (data.files.size > IMAGE_UPLOAD_SIZE) {
      toast({
        title: `Imagem maior que ${IMAGE_UPLOAD_SIZE / 1000}kb, por favor, escolha uma imagem menor`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })

      return
    }

    try {
      const { url } = await uploadImagePost(data.files)

      if (!url) {
        return
      }
      const response = await apiBlog.post(
        '/post',
        {
          title: data.title,
          content: data.content,
          category: 'brindes',
          authorId: userBlog.user.id,
          image: url,
          featured: data.featured,
          // tags: tags,
          tags: [],
          timeToRead: data.timeToRead,
        },
        {
          headers: {
            Authorization: `Bearer ${userBlog.token}`,
          },
        }
      )

      console.log(response)

      toast({
        title: 'Post criado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      dispatch(deleteDraft(data.title))
    } catch (error) {
      console.log(error)

      toast({
        title: 'Erro ao criar o post',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  async function handleSaveDraft(data) {
    console.log('nem entrou', drafts.drafts)
    if (data.files.size > IMAGE_UPLOAD_SIZE) {
      toast({
        title: `Imagem maior que ${IMAGE_UPLOAD_SIZE / 1000}kb, por favor, escolha uma imagem menor`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })

      return
    }

    try {
      const { url } = await uploadImagePost(data.files)

      if (!url) {
        return
      }

      const draft = {
        title: data.title,
        content: data.content,
        category: 'brindes',
        authorId: userBlog.user.id,
        image: url,
        featured: data.featured,
        // tags: tags,
        tags: [],
        timeToRead: data.timeToRead,
      }

      //see existir draft, e see tiver o mesmo titulo, atualiza o draft
      const draftIndex = drafts.drafts.findIndex((draft) => draft.title === data.title)

      if (draftIndex !== -1) {
        dispatch(updateDraft(draft))

        toast({
          title: 'Rascunho atualizado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
        console.log('drafttest', drafts.drafts)
      } else {
        dispatch(addDraft(draft))

        toast({
          title: 'Rascunho salvo com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
        console.log('drafttest2', drafts.drafts)
      }
    } catch (error) {
      console.log(error)

      toast({
        title: 'Erro ao salvar o rascunho',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  }

  function handleShowDrafts() {
    dispatch(toggleShowDrafts())
  }

  async function onSelectDraft(draft) {
    setValue('title', draft.title)
    setValue('content', draft.content)
    setValue('featured', draft.featured ? 'true' : 'false')
    setValue('timeToRead', draft.timeToRead)
    //transforma o draft.image em um blob e coloca no input files, draft.image é uma url

    const blob = await fetch(draft.image).then((res) => res.blob())

    const file = new File([blob], 'image.png', { type: 'image/png' })

    console.log(file)

    setValue('files', file)
  }

  return (
    <Flex flexDir="column" gap={3} maxW="1000px" mx="auto" disabled={formState.isSubmitting}>
      <DraftsList isOpen={drafts.showDrafts} onClose={handleShowDrafts} drafts={drafts.drafts} onSelectDraft={onSelectDraft} />

      <Button onClick={handleShowDrafts} colorScheme="gray" variant={drafts.showDrafts ? 'solid' : 'outline'} w="full">
        Rascunhos salvos
      </Button>
      <Flex flexDir="column">
        <DragAndDrop name="files" control={control} />
        {formState.errors.files && <Text color="red.500">{formState.errors.files.message}</Text>}
      </Flex>

      <Grid templateColumns="1fr 1fr 1fr" gap={3}>
        <Input placeholder="Título" {...register('title')} />
        <Select placeholder="Destaque no Blog" {...register('featured')}>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </Select>
        {/* <Select placeholder="Tags" {...register('tags')}>
        <option value="brindes">Brindes</option>
        <option value="brindes">Brindes</option>
        <option value="brindes">Brindes</option>
        <option value="brindes">Brindes</option>
      </Select> */}
        {/* <Input type="file" onChange={(e) => setImage(e.target.files[0])} /> */}
        {/* <InputFile onChange={(e) => setImage(e.target.files[0])} /> */}

        <Select placeholder="Tempo de leitura" {...register('timeToRead')}>
          <option value="5">5 minutos</option>
          <option value="10">10 minutos</option>
          <option value="15">15 minutos</option>
          <option value="20">20 minutos</option>
          <option value="25">25 minutos</option>
          <option value="30">30 minutos</option>
        </Select>
      </Grid>
      <Flex flexDir="column">
        <TextEditor control={control} />
        {formState.errors.content && <Text color="red.500">{formState.errors.content.message}</Text>}
      </Flex>

      <Flex mt="10" alignItems="center" gap={5}>
        <Button colorScheme="blue" alignSelf="flex-end" disabled={formState.isSubmitting} onClick={handleSubmit(handleSave)}>
          Publicar post
        </Button>
        <Button colorScheme="blue" alignSelf="flex-end" disabled={formState.isSubmitting} onClick={handleSubmit(handleSaveDraft)}>
          Salvar rascunho
        </Button>
      </Flex>
    </Flex>
  )
}
